module.exports = __webpack_public_path__ + "static/media/profilePic.e3c0d42c.png";